/**
 * Runtime configuration, served next to the app as `/config.json` and written by
 * the pipeline from Terraform outputs, so one build runs in any environment.
 * Nothing here is secret: pool and client IDs are public by design.
 */
export interface PortalConfig {
  env: string;
  apiUrl: string;
  userPoolId: string;
  clientId: string;
}

export async function loadConfig(fetcher: typeof fetch = fetch): Promise<PortalConfig> {
  const res = await fetcher('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  const value = (await res.json()) as Partial<PortalConfig>;
  for (const key of ['env', 'apiUrl', 'userPoolId', 'clientId'] as const)
    if (typeof value[key] !== 'string' || !value[key])
      throw new Error(`config.json: missing ${key}`);
  return value as PortalConfig;
}
